import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CNPatient } from '../models/cnpatient';
import { SNAgendaDay } from '../models/snagendaday';
import { SNItemFactory } from '../models/snitemfactory';
import { SNSMSMessage } from '../models/snsmsmessage';
import { BecareService } from './becare.service';
import { PatientService } from './patient.service';

@Injectable({
  providedIn: 'root'
})
export class SmsService {

  private static instance: SmsService = null;
  private currentpatient: CNPatient;

  constructor(private becare: BecareService, private patientSrv: PatientService) {
    SmsService.instance = this;
    this.patientSrv.patientSelectedEvent.subscribe(patientselected => {
      this.currentpatient = patientselected;
    });
    // Initiate with current selected patient
    this.currentpatient = this.patientSrv.patient;
  }

  public static getInstance(): SmsService {
    return SmsService.instance;
  }

  sanitize(phonenumber: string, country = 'be'): string {
    // clean separators
    let cleannumber = phonenumber.trim().replace(/-|\/|\.|,| /g, '');
    // remove zeros
    cleannumber = cleannumber.replace(/^0/g, '');
    switch (country) {
      case 'be':
      {
        if (cleannumber.substring(0, 1) === '32') {
          cleannumber = '00' + cleannumber;
        } else {
          cleannumber = '0032' + cleannumber;
        }
      }
      break;
    }
    return cleannumber;
  }

  isMobile(phonenumber: string, country = 'be'): boolean {
    const sanitized = this.sanitize(phonenumber, country);
    switch (country) {
      case 'be':
        return (sanitized.length !== 13) ? false : true;
        break;
    }
    return false;
  }

  patientSms(patient: CNPatient): Observable<SNSMSMessage[]> {
    return new Observable(observer => {
      this.becare.call('/fr/sms/user/' + patient.id + '/messagesv2').subscribe(results => {
        if (results.success === true && results.messages !== undefined) {
          const factory = new SNItemFactory();
          const messages = factory.itemsFromJson(results.messages);
          if (messages) {
            observer.next(messages);
          } else {
            observer.error('Unable to load messages');
          }
        } else {
          observer.error('Error requesting sms messages : ' + results.message);
        }
      });
    });
  }

  sendSmsPatient(patient: CNPatient, message: string, accessid: string): Observable<SNSMSMessage> {
    return new Observable(observer => {
      this.becare.call('/fr/sms/user/' + patient.id + '/send', [], {message, accessid}, 'post').subscribe(results => {
        if (results.success === true && results.message !== undefined) {
          const factory = new SNItemFactory();
          const sendmessage = factory.itemFromJson(results.message);
          if (sendmessage) {
            observer.next(sendmessage);
          } else {
            observer.error('Unable to load message');
          }
        } else {
          observer.error('Error requesting sms messages : ' + results.message);
        }
      });
    });
  }

  sendSmsAgenda(agenda: SNAgendaDay, message: string, accessid: string): Observable<SNSMSMessage> {
    return new Observable(observer => {
      this.becare.call('/fr/sms/agenda/day/' + agenda.id + '/send', [], {message, accessid}, 'post').subscribe(results => {
        if (results.success === true && results.message !== undefined) {
          const factory = new SNItemFactory();
          const sendmessage = factory.itemFromJson(results.message);
          if (sendmessage) {
            observer.next(sendmessage);
          } else {
            observer.error('Unable to load message');
          }
        } else {
          observer.error('Error requesting sms messages : ' + results.message);
        }
      });
    });
  }

}
